import script from "./ChiTietXuatTheoDoiTuongTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChiTietXuatTheoDoiTuongTable.vue?vue&type=script&lang=ts&setup=true"

import "./ChiTietXuatTheoDoiTuongTable.vue?vue&type=style&index=0&id=58f6fb47&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f6fb47"]])

export default __exports__